import { UseContentManager } from "../../Library/UseContentManager";
import ControlsMenu from "../ControlsMenu";
import { GetElementMargins,GetElementFontSize } from "../../Library/functions";
import TinyMCEEditor from '../TinyMCEEditor';

const Headline = ({data,lastIndexes,elmIndex,elementsCount}) => {

    const {showHelpers,indexToShowMenu,SelectElement,SetSettings} = UseContentManager();

    var showMenu = false;
    if(indexToShowMenu === lastIndexes)
        showMenu = true;

    var margins              = GetElementMargins(data,data.selectedTag);
    var subHeadlineClassName = GetElementFontSize(data,"subH");
    var className            = GetElementFontSize(data,data.selectedTag);

    const OnHeadlineChange = (content) => {
        if(indexToShowMenu)
            SetSettings(indexToShowMenu,"text",content,"headline");
    }
    const OnSubHeadlineChange = (content) => {
        if(indexToShowMenu)
            SetSettings(indexToShowMenu,"subText",content,"headline");
    }

    const OnFormatApply = (e) => {

        const regex = new RegExp('h[1-6]');
        if(indexToShowMenu && (regex.test(e.format)))
            SetSettings(indexToShowMenu,"selectedTag",e.format,"headline");
    }

    const OnFormatRemove = (e) => {

        const regex = new RegExp('h[1-6]');
        if(indexToShowMenu && (regex.test(e.format)))
            SetSettings(indexToShowMenu,"selectedTag","h1","headline");
    }

    return(
        <div className="cm-element-content">

            {showHelpers && showMenu ?
                <ControlsMenu 
                    element = "headline"
                    index = {lastIndexes} 
                    elementsCount = {elementsCount}
                    position = {elmIndex + 1}
                />
            :null}

            <div className={"cm-headline-element " + margins.styleClassName +  " " + data.className} style={margins.styles} >
                <div className={className}>
                    <TinyMCEEditor 
                        key = {indexToShowMenu}
                        value = {data.text}
                        forcedRootBlock = {"h1"}
                        OnEditorChange={(content) => OnHeadlineChange(content)}
                        toolbar = 'h1 h2 h3 h4 h5 h6 alignleft aligncenter alignright'
                        OnFormatApply = {(e) => OnFormatApply(e)}
                        OnFormatRemove = {(e) => OnFormatRemove(e)}
                    />
                </div>
                
                <div className={subHeadlineClassName}>
                    {data.hasSubText == 1 ?
                        <TinyMCEEditor 
                            key = {indexToShowMenu}
                            value = {data.subText}
                            OnEditorChange={(content) => OnSubHeadlineChange(content)}
                            toolbar = 'bold italic alignleft aligncenter alignright'
                        />
                        
                    :null}
                </div>
            </div>
            {showHelpers ?
                <div 
                    className={"cm-col-border" + (showMenu ? " cm-selected" : "")}
                    onClick={(e) => SelectElement(e,lastIndexes)}
                ></div>
            :null}
        </div>
    )
}

export default Headline;